module.exports = __webpack_public_path__ + "img/question-square-fill.3d92b873.svg";